import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { InformesService } from 'app/services/informes.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { HistoriaClinicaComponent } from 'app/modals/historia-clinica/historia-clinica.component';

@Component({
  selector: 'app-servicios-beneficiario',
  templateUrl: './servicios-beneficiario.component.html',
  styleUrls: ['./servicios-beneficiario.component.scss']
})
export class ServiciosBeneficiarioComponent implements OnInit {

  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, {static:true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  constructor(@Inject(MAT_DIALOG_DATA) private data, private _informe: InformesService, private dialog: MatDialog) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.tableOpt = [];
    this.dtOptions = {
      columns: [
        {
          title: 'N° Historia',
          render: (data,type,row,meta)=>{
            return `<a hc="${data}" class="consecutivo">${data}</a>`;
          }
        },
        {
          title: 'Fecha',
          data: 'reqdia'
        },
        {
          title: 'Hora',
          data: 'reqhor'
        },
        {
          title: 'Hora Llegada',
          data: 'reqhll'
        },
        {
          title: 'Médico',
          data: 'medico'
        },
        {
          title: 'Motivo',
          data: 'reqsig'
        },
        {
          title: 'Diagnóstico',
          data: 'diagnostico'
        },
        {
          title: 'Auxiliar',
          data: 'enfermero'
        },
        {
          title: 'Conductor',
          data: 'conductor'
        },
        {
          title: 'Tipo Servicio',
          data: 'tpsnom'
        },
        {
          title: ''
        }
      ]
    }
  }

  ngOnInit() {
    this._informe.ServiciosBeneficiarios(this.data.beneficiario_doc).subscribe((data:any) => {
      this.tableOpt = data.resultado;
      this.dtTrigger.next();
    });

    let that = this;
    $("body").off().on("click",".consecutivo",(e)=>{
      e.stopPropagation();
      if (!e.target.hasAttribute("hc")) return;
      let consecutivo:number = e.target.getAttribute('hc');
      this._informe.comprobarServicioDigital(consecutivo).subscribe((data:any) => {
        that.dialog.open(HistoriaClinicaComponent, {
          height: '75%',
          width: '65%',
          data: {
            reqreg: data.resultado[0].reqreg,
            consecutivo: consecutivo,
          }
        });
      });
    });
  }

}
